import type {
  SkyscannerRadarSearchV1Flightssection,
  SkyscannerRadarSearchV1Search,
  SkyscannerRadarSearchV1Sections,
} from '@skyscanner-internal/radar-web-http-client';

type Section = SkyscannerRadarSearchV1Sections.Section;
type SectionContext = SkyscannerRadarSearchV1Sections.SectionContext;
type FlightsSection = SkyscannerRadarSearchV1Flightssection.FlightsSection;
type SearchResponse = SkyscannerRadarSearchV1Search.SearchResponse;

const findCheapestInBucket = (
  bucketId: string,
  buckets: FlightsSection['buckets'],
  results: FlightsSection['results'],
) => {
  const bucket = buckets?.find((b) => b.id === bucketId);
  const bucketResultIds = bucket?.resultIds || [];

  const itineraries = Object.entries(results || [])
    .filter(([resultId]) => bucketResultIds.includes(resultId))
    .map(([resultId, itinerary]) => ({
      ...itinerary.itinerary,
      id: resultId,
    }));

  return itineraries.reduce((acc, currentItinerary) => {
    const accPrice =
      acc?.quote?.price?.amount != null ? Number(acc.quote.price.amount) : null;
    const currentPrice =
      currentItinerary?.quote?.price?.amount != null
        ? Number(currentItinerary.quote.price.amount)
        : null;

    if (
      currentPrice != null &&
      !Number.isNaN(currentPrice) &&
      (accPrice == null || Number.isNaN(accPrice) || currentPrice < accPrice)
    ) {
      return currentItinerary;
    }
    return acc;
  }, itineraries[0]);
};

export const transformRadarSearchResponse = (response: SearchResponse) => {
  const hasFlightsSection = (
    section: Section,
  ): section is {
    context: SectionContext;
    flights: FlightsSection;
  } => 'flights' in section && !!section.flights;

  const pollingSessionComplete = response.pollingSession?.complete;
  const pollingSessionToken = response.pollingSession?.token;
  const flightsSection = response.sections?.find(hasFlightsSection);
  const buckets = flightsSection?.flights?.buckets;
  const results = flightsSection?.flights?.results;

  const cheapestItinerary = findCheapestInBucket('Cheapest', buckets, results);
  const cheapestDirectItinerary = findCheapestInBucket(
    'Direct',
    buckets,
    results,
  );

  return {
    cheapestItinerary,
    cheapestDirectItinerary,
    pollingSessionToken,
    pollingSessionComplete,
  };
};
